/**
 * WordPress dependencies.
 */
import { __,_x } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';

import {
    PanelBody,
    SelectControl,
    RangeControl,
} from '@wordpress/components';

import {
    Fragment
} from '@wordpress/element';

/**
* Internal dependencies
*/

import { VayuBlocksDevice } from '@vayu-blocks/device-control';

const InsSettings = ({
    attributes,
    setAttributes
}) => {
       
    const getView = VayuBlocksDevice(); 

    const getGridColumn = () => {
        switch (getView) {
            case 'Desktop':
                return attributes.gridColumn ?? 3; 
            case 'Tablet':
                return attributes.gridColumnTablet ?? 3;
            case 'Mobile':
                return attributes.gridColumnMobile ?? 3;
            default:
                return 3;
        }
    };

    const changeGridColumn = value => {

		if ( 'Desktop' === getView ) {
			setAttributes({ gridColumn: value, gridColumnTablet: value, gridColumnMobile: value });
		} else if ( 'Tablet' === getView ) {
			setAttributes({ gridColumnTablet: value, gridColumnMobile: value });
		} else if ( 'Mobile' === getView ) {
			setAttributes({ gridColumnMobile: value });
		}

	};
	
    return (
        <Fragment>
        <InspectorControls>
                <Fragment>
                <PanelBody title={ __( 'Layout Setting', 'vayu-blocks' ) }
                    className="th-adv-wrapper-loop-setting-panel" initialOpen={ true }   
                >

                      <SelectControl
								label={ __( 'Layout', 'vayu-blocks' ) }
								value={ attributes.layoutType}
								options={ [
									{ label:  __( 'List', 'vayu-blocks' ), value: 'default' },
									{ label: __( 'Grid', 'vayu-blocks' ), value: 'grid' },
									
								] }
								onChange={ e => setAttributes({ layoutType: e }) }
					/>
                              { ('grid' == attributes.layoutType) && (
                                    	
									
									<RangeControl
										value={ getGridColumn() !== undefined ? getGridColumn() : 3 }
										onChange={ changeGridColumn }
										step={ 1 }
										min={ 1}
										max={ 6 }
										initialPosition = {3}
										allowReset={ true }
									/>
									
                              )}
               
                </PanelBody>
                </Fragment>
                 </InspectorControls>
                </Fragment>
               
        )

}

export default InsSettings;